module.exports = __webpack_public_path__ + "static/media/icon3.57b4f6e5.svg";